import { useImperativeHandle, forwardRef, useState, useEffect, useLocation, post, get } from '@/common'
import { Modal, message } from 'antd';
import moment from 'moment';

function Main(props: any, ref: any) {
    const location = useLocation()
    const pathname = props.apiUrl || location.pathname
    const [visible, setVisible] = useState<any>();
    const form = props.children.props.form
    const list = props.nref.list.current
    const [action, setAction] = useState('add');
    const [id, setId] = useState<string>();
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState('操作');
    const width = props.width || 520
    const id_field = props.idField || 'id'

    const format = {
        date: 'YYYY-MM-DD',
        date_time: 'YYYY-MM-DD HH:mm:ss',
        time: 'HH:mm:ss'
    }
    // 暴露方法
    useImperativeHandle(ref, () => ({
        add: async () => {
            form.resetFields()
            setVisible(true)
            setAction('add')
            setTitle(`添加${props.name}`)
        },
        edit: async (id: string) => {
            form.resetFields()
            setVisible(true)
            setAction('edit')
            setTitle(`修改${props.name}`)
            return getDetail(id)
        },
        editPw: async (id: string) => {
            form.resetFields()
            setVisible(true)
            setAction('edit_pw')
            setTitle(`修改密码`)
            setId(id)
        },
        getAction: () => {
            return action
        },
        getOpen: () => {
            return visible
        },
        setOpen: (data: any) => {
            setVisible(data)
        },
        ok: () => {
            ok()
        }
    }));
    const getDetail = async (id: string) => {
        return get(props.detailUrl ? `${props.detailUrl}/${id}` : `${pathname}/detail/${id}`).then(data => {
            data = data.data
            // 格式化数据
            if (props.format) {
                if (props.format.date) {
                    props.format.date.forEach((e: any) => {
                        data[e] = moment(data[e], format.date)
                    })
                }
                if (props.format.date_time) {
                    props.format.date_time.forEach((e: any) => {
                        data[e] = moment(data[e], format.date_time)
                    })
                }
            }
            if (props.getDetailSuccces && typeof (props.getDetailSuccces) == "function") props.getDetailSuccces(data)
            form.setFieldsValue(data)
            setId(data[id_field])
            return data
        })
    }
    useEffect(() => {
        setVisible(props.visible)
    }, [props.visible])
    const ok = () => {
        if (loading) return
        setLoading(true)
        // 验证表单
        // form.validateFields().then((data: any) => {
        form.validateFields().then(() => {
            let data = form.getFieldsValue()
            // 格式化数据
            if (props.format) {
                if (props.format.date) {
                    props.format.date.forEach((e: any) => {
                        if (!data[e]) return
                        data[e] = data[e].format(format.date)
                    })
                }
                if (props.format.date_time) {
                    props.format.date_time.forEach((e: any) => {
                        if (!data[e]) return
                        data[e] = data[e].format(format.date_time)
                    })
                }
            }
            // 提交前处理
            if (props.submitBefore && typeof (props.submitBefore) == "function") if (props.submitBefore(data) === false) {
                setLoading(false)
                return false
            }
            // // 追加字段
            // if (props.formName) {
            //     props.formName.forEach((e: any) => {
            //         data[e] = form.getFieldValue(e)
            //     });
            // }
            let url = `${pathname}/${action}`
            if (['edit', 'edit_pw'].indexOf(action) > -1) url += `/${id}`
            post(url, data).then((data) => {
                if (data.code) return
                setVisible(false)
                // 更新列表
                list.getList()
                if (props.submitSuccces && typeof (props.submitSuccces) == "function") props.submitSuccces(data.data)
            })
                .finally(() => {
                    setLoading(false)
                })
        })
            .catch(() => {
                setLoading(false)
            })
    }
    const cancel = () => {
        setVisible(false)
    }
    return (
        <Modal title={title} open={visible} onOk={ok} onCancel={cancel} confirmLoading={loading}
            maskClosable={false}
            width={width}
            forceRender={props.forceRender}
            footer={props.footer}
        >
            {props.children}
        </Modal>
    )
}

export default forwardRef(Main)